// Pricing packages for Quanturama
export const PACKAGES = [
  {
    id: 'tier-1',
    tier: 1,
    name: 'First System',
    price: '$1,700',
    priceNote: 'Fixed project price',
    subtitle: 'One pipeline or bot. Scoped, built, and shipped.',
    description: 'The right entry point for operators who need one thing done properly. A single automation pipeline, trading bot, or Web3 integration — architected, built, documented, and handed off.',
    cta: 'Start Here',
    ctaLink: '/contact',
    features: [
      'Single automation pipeline or trading bot',
      'Workflow design & API integrations',
      'Monitoring, alerts & documentation',
      '1 month async support included',
      'Full handoff — yours to run'
    ],
    highlighted: false
  },
  {
    id: 'tier-2',
    tier: 2,
    name: 'Operator Stack',
    price: '$4,000',
    priceNote: 'Fixed project price',
    subtitle: 'Multiple systems. One coherent architecture.',
    description: 'For operators ready to connect the pieces. Multi-pipeline architecture with AI agents, CRM automation, analytics, and priority async support.',
    cta: 'Build My Stack',
    ctaLink: '/contact',
    features: [
      'Everything in First System',
      'Multi-pipeline architecture',
      'AI agent integration',
      'CRM & data flow automation',
      'Analytics & reporting dashboard',
      'Priority async support'
    ],
    highlighted: true
  },
  {
    id: 'tier-3',
    tier: 3,
    name: 'Full Architecture',
    price: 'Enterprise',
    priceNote: 'Scoped per project',
    subtitle: 'From whiteboard to production. We own the build.',
    description: 'Full-scope engagement. Custom trading bot or DApp, smart contracts, multi-agent orchestration, Web3 infrastructure. For teams who need a systems partner, not a vendor.',
    cta: 'Get Full Build',
    ctaLink: '/contact',
    features: [
      'Everything in Operator Stack',
      'Custom trading bot or DApp',
      'Smart contract development',
      'Multi-agent orchestration',
      'Web3 infrastructure deployment',
      '2 months dedicated support'
    ],
    highlighted: false
  }
];

export const CUSTOM_PROJECTS = {
  title: 'Protocols, Ecosystems & Complex Systems',
  description: 'Multi-agent architectures, DApp marketplaces, token ecosystems, and trading infrastructure at scale — scoped and priced per project.',
  cta: 'Get a Custom Quote'
};
